import PropTypes from 'prop-types';

export const CheckboxEntity = PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }));
export const DropDownEntity = PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }));
export const RadioEntity = PropTypes.arrayOf(
  PropTypes.shape({ text: PropTypes.string, title: PropTypes.string, hideValue: PropTypes.bool })
);
export const RangeEntity = PropTypes.arrayOf(PropTypes.number);
export const OptionsEntity = PropTypes.oneOfType([CheckboxEntity, DropDownEntity, RangeEntity, RadioEntity]);

export const FiltersEntity = PropTypes.objectOf(OptionsEntity);
